import React from "react";
import {Outlet} from "react-router-dom";
import HeaderComponent from "../components/HeaderComponent";
import LoadingBarComponent from "../components/LoadingBarComponent";

const AdminLayout = () => {
    return (
        <>
            <LoadingBarComponent/>
            <HeaderComponent/>
            <Outlet/>
        </>
    );
};

export default AdminLayout;
